import { render, staticRenderFns } from "./M2hUnboxChallengeWidgetOne.vue?vue&type=template&id=a33310cc&scoped=true&"
import script from "./M2hUnboxChallengeWidgetOne.vue?vue&type=script&lang=js&"
export * from "./M2hUnboxChallengeWidgetOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33310cc",
  null
  
)

export default component.exports